import React from 'react';
import { useMetaPixel } from './hooks/useMetaPixel';
import { Hero } from './components/Hero';
import { Problema } from './components/Problema';
import { Solucion } from './components/Solucion';
import { ComoFunciona } from './components/ComoFunciona';
import { AntesDespues } from './components/AntesDespues';
import { QueAprenderas } from './components/QueAprenderas';
import { Oferta } from './components/Oferta';
import { Bonos } from './components/Bonos';
import { Testimonios } from './components/Testimonios';
import { Creador } from './components/Creador';
import { Garantia } from './components/Garantia';
import { Faq } from './components/Faq';
import { CtaFinal } from './components/CtaFinal';
import { Footer } from './components/Footer';
export function App() {
  useMetaPixel();
  return <div className="w-full min-h-screen font-poppins text-white bg-negro overflow-x-hidden" data-id="element-0">
      <Hero data-id="element-1" />
      <Problema data-id="element-2" />
      <Solucion data-id="element-3" />
      <ComoFunciona data-id="element-4" />
      <AntesDespues data-id="element-5" />
      <QueAprenderas data-id="element-6" />
      <Oferta data-id="element-7" />
      <Bonos data-id="element-8" />
      <Testimonios data-id="element-9" />
      <Creador data-id="element-10" />
      <Garantia data-id="element-11" />
      <Faq data-id="element-12" />
      <CtaFinal data-id="element-13" />
      <Footer data-id="element-14" />
    </div>;
}